import { Check, X } from "lucide-react";

export const RULES = [
  ["At least 8 characters", (p) => p.length >= 8],
  ["An uppercase letter", (p) => /[A-Z]/.test(p)],
  ["A lowercase letter", (p) => /[a-z]/.test(p)],
  ["A number", (p) => /\d/.test(p)],
  ["A symbol (e.g. ! @ # $)", (p) => /[^A-Za-z0-9]/.test(p)],
];

export const passwordOk = (p) => RULES.every(([, fn]) => fn(p));

export const PasswordRules = ({ value, dark = false }) => (
  <ul className="flex flex-col gap-1 mt-2" data-testid="password-rules">
    {RULES.map(([label, fn], i) => {
      const ok = fn(value);
      return (
        <li key={label} className={`flex items-center gap-1.5 text-xs ${ok ? "text-emerald-600" : dark ? "text-white/50" : "text-gray-500"}`} data-testid={`password-rule-${i}`} data-ok={ok}>
          {ok ? <Check className="w-3.5 h-3.5" /> : <X className="w-3.5 h-3.5" />}{label}
        </li>
      );
    })}
  </ul>
);
